import Vue from "vue";
import ElementUI from "element-ui";

import DateShortCut from "@ui/DateShortCut/DateShortCut.vue";
import CwCollapse from "@ui/Collapse/Collapse.vue";
import FontTip from "@ui/FontTip/FontTip";
import AgencyTree from "@ui/AgencyTree/AgencyTree";
import AgencyTreeTransfer from "@ui/AgencyTreeTransfer/AgencyTreeDetail";
import SelectInterval from "@ui/SelectInterval/SelectInterval";
import DescText from "@ui/DescText/DescText.vue";

Vue.component('date-short-cut', DateShortCut);
Vue.component('hq-collapse', CwCollapse);
Vue.component('font-tip', FontTip);
Vue.component('agency-tree', AgencyTree);
Vue.component('agency-transfer', AgencyTreeTransfer);
Vue.component('select-interval', SelectInterval);
Vue.component('desc-text', DescText);

// 选择时间控件默认不可清空
ElementUI.DatePicker.mixins[0].props.editable.default = false;
ElementUI.DatePicker.mixins[0].props.clearable.default = false;
ElementUI.DatePicker.props.valueFormat = {
  default: 'timestamp'
};
ElementUI.Pagination.props.layout.default = 'total, sizes, jumper, -> ,prev, pager, next';

Vue.use(ElementUI);



// WEBPACK FOOTER //
// ./src/components/core/registerComponent.js